export const LOAD_PORTFOLIO_DASHBOARD_REQUEST = 'portfolio-dashboard/LOAD_PORTFOLIO_DASHBOARD_REQUEST';
export const LOAD_PORTFOLIO_DASHBOARD_SUCCESS = 'portfolio-dashboard/LOAD_PORTFOLIO_DASHBOARD_SUCCESS';
export const LOAD_PORTFOLIO_DASHBOARD_FAILURE = 'portfolio-dashboard/LOAD_PORTFOLIO_DASHBOARD_FAILURE';

export const ADD_CHART_TO_DASHBOARD_REQUEST = 'portfolio-dashboard/ADD_CHART_TO_DASHBOARD_REQUEST';
export const ADD_CHART_TO_DASHBOARD_SUCCESS = 'portfolio-dashboard/ADD_CHART_TO_DASHBOARD_SUCCESS';
export const ADD_CHART_TO_DASHBOARD_FAILURE = 'portfolio-dashboard/ADD_CHART_TO_DASHBOARD_FAILURE';

export const LOAD_DASHBOARD_CHARTS_REQUEST = 'portfolio-dashboard/LOAD_DASHBOARD_CHARTS_REQUEST';
export const LOAD_DASHBOARD_CHARTS_SUCCESS = 'portfolio-dashboard/LOAD_DASHBOARD_CHARTS_SUCCESS';
export const LOAD_DASHBOARD_CHARTS_FAILURE = 'portfolio-dashboard/LOAD_DASHBOARD_CHARTS_FAILURE';

export const UPDATE_DASHBOARD_CHART_REQUEST = 'portfolio-dashboard/UPDATE_CHART_REQUEST';
export const UPDATE_DASHBOARD_CHART_SUCCESS = 'portfolio-dashboard/UPDATE_CHART_SUCCESS';
export const UPDATE_DASHBOARD_CHART_FAILURE = 'portfolio-dashboard/UPDATE_CHART_FAILURE';

export const DELETE_CHART_FROM_DASHBOARD_REQUEST = 'portfolio-dashboard/DELETE_CHART_FROM_DASHBOARD_REQUEST';
export const DELETE_CHART_FROM_DASHBOARD_SUCCESS = 'portfolio-dashboard/DELETE_CHART_FROM_DASHBOARD_SUCCESS';
export const DELETE_CHART_FROM_DASHBOARD_FAILURE = 'portfolio-dashboard/DELETE_CHART_FROM_DASHBOARD_FAILURE';

export const UPDATE_RECENTLY_SHARED_PEOPLE = 'portfolio-dashboard/SET_RECENTLY_SHARED_PEOPLE';

export const ADD_PORTFOLIO_DASHBOARD_REQUEST = 'portfolio-dashboard/ADD_PORTFOLIO_DASHBOARD_REQUEST'
export const ADD_PORTFOLIO_DASHBOARD_SUCCESS = 'portfolio-dashboard/ADD_PORTFOLIO_DASHBOARD_SUCCESS'
export const ADD_PORTFOLIO_DASHBOARD_FAILURE = 'portfolio-dashboard/ADD_PORTFOLIO_DASHBOARD_FAILURE'

export const LOAD_PORTFOLIO_DASHBOARDS_REQUEST = 'portfolio-dashboard/LOAD_PORTFOLIO_DASHBOARDS_REQUEST'
export const LOAD_PORTFOLIO_DASHBOARDS_SUCCESS = 'portfolio-dashboard/LOAD_PORTFOLIO_DASHBOARDS_SUCCESS'
export const LOAD_PORTFOLIO_DASHBOARDS_FAILURE = 'portfolio-dashboard/LOAD_PORTFOLIO_DASHBOARDS_FAILURE'

export const UPDATE_PORTFOLIO_DASHBOARD_REQUEST = 'portfolio-dashboard/UPDATE_PORTFOLIO_DASHBOARD_REQUEST'
export const UPDATE_PORTFOLIO_DASHBOARD_SUCCESS = 'portfolio-dashboard/UPDATE_PORTFOLIO_DASHBOARD_SUCCESS'
export const UPDATE_PORTFOLIO_DASHBOARD_FAILURE = 'portfolio-dashboard/UPDATE_PORTFOLIO_DASHBOARD_FAILURE'

export const REMOVE_PORTFOLIO_DASHBOARD_REQUEST = 'portfolio-dashboard/REMOVE_PORTFOLIO_DASHBOARD_REQUEST'
export const REMOVE_PORTFOLIO_DASHBOARD_SUCCESS = 'portfolio-dashboard/REMOVE_PORTFOLIO_DASHBOARD_SUCCESS'
export const REMOVE_PORTFOLIO_DASHBOARD_FAILURE = 'portfolio-dashboard/REMOVE_PORTFOLIO_DASHBOARD_FAILURE'

export const DUPLICATE_PORTFOLIO_DASHBOARD_REQUEST = 'portfolio-dashboard/DUPLICATE_PORTFOLIO_DASHBOARD_REQUEST';
export const DUPLICATE_PORTFOLIO_DASHBOARD_SUCCESS = 'portfolio-dashboard/DUPLICATE_PORTFOLIO_DASHBOARD_SUCCESS';
export const DUPLICATE_PORTFOLIO_DASHBOARD_FAILURE = 'portfolio-dashboard/DUPLICATE_PORTFOLIO_DASHBOARD_FAILURE';

export const MOVE_CHART_TO_DASHBOARD_REQUEST = 'portfolio-dashboard/MOVE_CHART_TO_DASHBOARD_REQUEST';
export const MOVE_CHART_TO_DASHBOARD_SUCCESS = 'portfolio-dashboard/MOVE_CHART_TO_DASHBOARD_SUCCESS';
export const MOVE_CHART_TO_DASHBOARD_FAILURE = 'portfolio-dashboard/MOVE_CHART_TO_DASHBOARD_FAILURE';

export const CONVERT_OLD_CHART_TO_NEW_CHART = 'portfolio-dashboard/CONVERT_OLD_CHART_TO_NEW_CHART'

export const UPDATE_DASHBOARD_LAYOUT = 'portfolio-dashboard/UPDATE_DASHBOARD_LAYOUT'